import React, { useEffect, useState } from "react";
import "./App.css";
import { AuthProvider } from "./Context/AuthContext";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { Register } from "./Components/Register/Register";
import { Logout } from "./Utils/Logout";
import { Header } from "./Components/Header/header";
import { Footer } from "./Components/Footer/footer";
import { AlertProvider } from "./Context/AlertContext";
import Notification from "./Components/Notification/notification";
import { UserRoutesv1 } from "./Components/User/UserRoutes";
import { CookiePopup } from "./Components/CookiePopup/CookiePopup";

import { BeneficiaryLogin } from "./Components/Login/BeneficiaryLogin";
import { BeneficiaryOTP } from "./Components/Login/BeneficiaryOTP";
import Home from "./Components/Beneficiary/Home";
import { FSessionTimeout } from "./Components/SessionTimeout";
import { AdminRoutesv1 } from "./Components/Administrator/AdminRoutes";

import { CheckEmail } from "./Components/Register/CheckEmail";
import { AccountActivated } from "./Components/User/Account Activated/AccounActivated";
import { NotFound } from "./Components/Not Found/NotFound";
import { TokenRoutes } from "./TokenRoutes";
import { BeneficiarySorry } from "./Components/Beneficiary/BeneficiarySorry";
import { BeneficiaryConditions } from "./Components/Beneficiary/BeneficiaryConditions";
import { RequireBeneficiaryTerms } from "./Components/Beneficiary/RequireTerms";
import HelpCenter from "./Components/Pages/HelpCenter/HelpCenter";
import EstatePlanning from "./Components/Pages/EstatePlanning/EstatePlanning";
import ContactUs from "./Components/Pages/ContactUs/ContactUs";
import { EmployeeProvider } from "./Components/Administrator/AdminProvider";
import ReactGA from "react-ga4";
import TermsEnglish from "./Components/Terms/TermsEnglish";
import TermsFrench from "./Components/Terms/TermsFrench";
import PrivacyFrench from "./Components/Terms/PrivacyFrench";
import PrivacyEnglish from "./Components/Terms/PrivacyEnglish";
import Privacy from "./Components/Terms/Privacy";
import Terms from "./Components/Terms/Terms";
import HowItWorks from "./Components/Pages/HowItWorks/HowItWorks";
import { PartnerRoutes } from "./Components/Partner/PartnerRoutes";
import { Newsletter } from "./Components/User/Newsletter/Newsletter";
import { RegisterRedirection } from "./Components/Register/RegisterRedirection";
import { LanguageRedirection } from "./Components/User/languageRedirection";
import { RegisterWithRequiredPhone } from "./Components/Register/RegisterWithRequiredPhone";

ReactGA.initialize("G-404N0K12VY", { debug: true });
const RedirectWithReferral = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const referral = params.get("referral");
    const id = params.get("id");
    const id_url = id?`&id=${id}`:``
    if (referral) {
      navigate(`/register?referral=${referral}${id_url}`, { replace: true });
    } else navigate("/login", { replace: true });
  }, [location, navigate]);

  return null; // No UI is rendered by this component
};
export function App() {
  const [websiteLoading, setWebsiteLoading] = useState(true);
  useEffect(() => {
    document.documentElement.style.overflow = "hidden";

    setTimeout(() => {
      document.documentElement.style.overflowY = "auto";
      document.documentElement.style.overflowX = "hidden";

      setWebsiteLoading(false);
    }, 2000);
  }, []);
  useEffect(() => {
    //Captcha
    // const script = document.createElement("script")
    // script.src = "https://www.google.com/recaptcha/api.js?render=6Ldi00MoAAAAAOhEarj3D8oPKndxNMGHPNVPeciu"
    // document.body.appendChild(script)
    //ChatBot Intercom
  }, []);

  useEffect(() => {
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (isIOS) {
      document.body.classList.add("ios-input");
    } else {
      document.body.classList.remove("ios-input");
    }
  }, []);
  return (
    <>
      <EmployeeProvider>
        <AuthProvider>
          <AlertProvider>
            <CookiePopup></CookiePopup>

            <Routes>
              <Route
                path="redirect/*"
                element={
                  <>
                    <Header elements={[]} />
                    <LanguageRedirection />
                    <Footer />
                  </>
                }
              />
              <Route
                path="/beneficiary/login"
                element={
                  <>
                    <Header />
                    <BeneficiaryLogin />
                    <Footer />
                  </>
                }
              ></Route>
              <Route path="/" element={<RedirectWithReferral />} />
              <Route
                path="/beneficiary/login"
                element={
                  <>
                    <Header />
                    <BeneficiaryLogin />
                    <Footer />
                  </>
                }
              ></Route>
              <Route
                path="/terms-and-conditions"
                element={
                  <>
                    <Terms />
                  </>
                }
              ></Route>
              <Route
                path="/en/user/terms-and-conditions"
                element={
                  <>
                    <Header />
                    <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
                      <TermsEnglish />
                    </div>
                    <Footer />
                  </>
                }
              ></Route>
              <Route
                path="/en/terms-and-conditions"
                element={
                  <>
                    <Header />
                    <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
                      <TermsEnglish />
                    </div>
                    <Footer />
                  </>
                }
              ></Route>
              <Route
                path="/terms-and-conditions/en"
                element={
                  <>
                    <Header />
                    <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
                      <TermsEnglish />
                    </div>
                    <Footer />
                  </>
                }
              ></Route>
              <Route
                path="/fr/user/terms-and-conditions"
                element={
                  <>
                    <Header />
                    <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
                      <TermsFrench />
                    </div>
                    <Footer />
                  </>
                }
              ></Route>
              <Route
                path="/fr/terms-and-conditions"
                element={
                  <>
                    <Header />
                    <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
                      <TermsFrench />
                    </div>
                    <Footer />
                  </>
                }
              ></Route>
              <Route
                path="/terms-and-conditions/fr"
                element={
                  <>
                    <Header />
                    <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
                      <TermsFrench />
                    </div>
                    <Footer />
                  </>
                }
              ></Route>
              <Route
                path="/privacy-policy"
                element={
                  <>
                    <Privacy />
                  </>
                }
              ></Route>
              <Route
                path="/fr/privacy-policy"
                element={
                  <>
                    <Header />
                    <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
                      <PrivacyFrench />
                    </div>
                    <Footer />
                  </>
                }
              ></Route>
              <Route
                path="/privacy-policy/fr"
                element={
                  <>
                    <Header />
                    <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
                      <PrivacyFrench />
                    </div>
                    <Footer />
                  </>
                }
              ></Route>
              <Route
                path="/fr/user/privacy-policy"
                element={
                  <>
                    <Header />
                    <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
                      <PrivacyFrench />
                    </div>
                    <Footer />
                  </>
                }
              ></Route>
              <Route
                path="/en/user/privacy-policy"
                element={
                  <>
                    <Header />
                    <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
                      <PrivacyEnglish />
                    </div>
                    <Footer />
                  </>
                }
              ></Route>
              <Route
                path="/en/user/privacy-policy"
                element={
                  <>
                    <Header />
                    <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
                      <PrivacyEnglish />
                    </div>
                    <Footer />
                  </>
                }
              ></Route>
              <Route
                path="/en/privacy-policy"
                element={
                  <>
                    <Header />
                    <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
                      <PrivacyEnglish />
                    </div>
                    <Footer />
                  </>
                }
              ></Route>
              <Route
                path="/privacy-policy/en"
                element={
                  <>
                    <Header />
                    <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
                      <PrivacyEnglish />
                    </div>
                    <Footer />
                  </>
                }
              ></Route>
              <Route
                path="/beneficiary/login/OTP"
                element={
                  <>
                    <FSessionTimeout
                      onIdlePath="/beneficiary/login"
                      timeout={2 * 60 * 1000}
                    />
                    <Header elements={[]} />
                    <BeneficiaryOTP />
                    <Footer />
                  </>
                }
              ></Route>
              <Route
                path="/beneficiary/home"
                element={
                  <>
                    <FSessionTimeout onIdlePath="/beneficiary/login" />
                    <Header elements={undefined} />
                    <Home />
                    <Footer />
                  </>
                }
              ></Route>
              <Route
                path="/sorrypage"
                element={
                  <>
                    <Header elements={undefined} />
                    <BeneficiarySorry />
                    <Footer />
                  </>
                }
              ></Route>
              <Route
                path="/beneficiary/terms"
                element={
                  <RequireBeneficiaryTerms>
                    <FSessionTimeout />
                    <Header />
                    <BeneficiaryConditions />
                    <Footer />
                  </RequireBeneficiaryTerms>
                }
              ></Route>
              <Route
                path="/register"
                element={
                  <>
                    <Header elements={[]} />
                    <Register />
                    <Footer />
                  </>
                }
              ></Route>
              <Route
                path="/register-now"
                element={
                  <>
                    <Header elements={[]} />
                    <RegisterWithRequiredPhone />
                    <Footer />
                  </>
                }
              ></Route>
              <Route
                path="/register/confirm/:redirect_id"
                element={
                  <>
                    <Header elements={[]} />
                    <RegisterRedirection />
                    <Footer />
                  </>
                }
              ></Route>
              <Route
                path="/account/activated"
                element={
                  <>
                    <Header elements={[]} />
                    <AccountActivated />
                    <Footer />
                  </>
                }
              ></Route>
              <Route
                path="/checkemail"
                element={
                  <>
                    <Header elements={[]} />
                    <CheckEmail
                      title="Please check you email"
                      email_address="xabiereiza"
                      onBack={"/register"}
                    />
                    <Footer />
                  </>
                }
              ></Route>
              <Route
                path="/logout"
                element={
                  <>
                    <AuthProvider>
                      <Header elements={[]} />
                      <Logout />
                      <Footer />
                    </AuthProvider>
                  </>
                }
              ></Route>
              <Route
                path="Help-Center"
                element={
                  <>
                    <Header elements={null} />
                    <HelpCenter />
                    <Footer />
                  </>
                }
              ></Route>
              <Route
                path="Help-Center/estate-planning"
                element={
                  <>
                    <Header elements={null} />
                    <EstatePlanning />
                    <Footer />
                  </>
                }
              ></Route>
              <Route
                path="/How-it-works"
                element={
                  <>
                    <Header elements={null} />
                    <HowItWorks />
                    <Footer />
                  </>
                }
              ></Route>
              <Route
                path="/contact-us"
                element={
                  <>
                    <Header elements={null} />
                    <ContactUs />
                    <Footer />
                  </>
                }
              ></Route>
              <Route
                path="/help/unsubscribe"
                element={
                  <>
                    <Header elements={null} />
                    <Newsletter />
                    <Footer />
                  </>
                }
              ></Route>
              {/* <Route path="/admin/email/translate" element={
              <>
                <Header elements= {null}/>
                <EmailTranslation />
                <Footer />
                </>
            }>
          </Route> */}
              {/* <Route path="/pruebanewparnetvalidation" element={
              <>
                <Header elements= {null}/>
                <PartneValidationPrueba />
                <Footer />
                </>
            }>
          </Route> */}
              <Route
                path="/*"
                element={
                  <>
                    <Header elements={[]} />
                    <NotFound />
                    <Footer />
                  </>
                }
              ></Route>
              {TokenRoutes}
              {UserRoutesv1}
              {AdminRoutesv1}
              {PartnerRoutes}
            </Routes>

            {/* <UserRoutes/> */}
            {/* <AdminRoutes /> */}
            {/* <TokenRoutes /> */}

            <div style={{ zIndex: "10", position: "relative" }}>
              <Notification />
            </div>
          </AlertProvider>
        </AuthProvider>
      </EmployeeProvider>
    </>
  );
}
